import { Image, Text, View } from '@react-pdf/renderer';

import { CommentarySection } from '../../components/CommentarySection.tsx';
import { Tkv2PDFPage } from '../../components/Tkv2PDFPage.tsx';
import { fontStyles, certificationPageStyles as styles } from '../../styles.ts';
import { CertificationSignaturePageProps } from '../../types.ts';

export const CertificationSignaturePage = ({
  subjectAddress,
  commentaryV2,
  effectiveDate,
  inspectionDate,
  licenseNumber,
  licenseState,
  licenseExpiration,
  licenseType,
  signedAt,
  appraiserName,
  signatureImages,
  inspectionData,
}: CertificationSignaturePageProps) => (
  <Tkv2PDFPage title="Certification" address={subjectAddress}>
    <View style={{ width: '100%' }}>
      {commentaryV2?.reconciliation?.certificationCommentary && (
        <CommentarySection
          title="Additional Certification Commentary"
          commentary={commentaryV2.reconciliation?.certificationCommentary}
        />
      )}
      <View style={styles.signatureSection}>
        <Text style={styles.title}>Appraiser Signature</Text>
        <View style={styles.signatureContainer}>
          <View style={styles.signatureSectionFieldsContainer}>
            <Text style={styles.signatureSectionLabel}>Appraiser Name</Text>
            <Text style={styles.signatureSectionField}>{appraiserName}</Text>
          </View>
          {inspectionData?.hasInspection && (
            <View style={styles.signatureSectionFieldsContainer}>
              <Text style={styles.signatureSectionLabel}>Inspection Date</Text>
              <Text style={styles.signatureSectionField}>{inspectionDate}</Text>
            </View>
          )}
          <View style={styles.signatureSectionFieldsContainer}>
            <Text style={styles.signatureSectionLabel}>Effective Date</Text>
            <Text style={styles.signatureSectionField}>{effectiveDate}</Text>
          </View>
          <View style={styles.signatureSectionFieldsContainer}>
            <Text style={styles.signatureSectionLabel}>License State</Text>
            <Text style={styles.signatureSectionField}>{licenseState}</Text>
          </View>
          <View style={styles.signatureSectionFieldsContainer}>
            <Text style={styles.signatureSectionLabel}>License ID</Text>
            <Text style={styles.signatureSectionField}>{licenseNumber}</Text>
          </View>
          <View style={styles.signatureSectionFieldsContainer}>
            <Text style={styles.signatureSectionLabel}>License Expiration</Text>
            <Text style={styles.signatureSectionField}>{licenseExpiration}</Text>
          </View>
          <View style={styles.signatureSectionFieldsContainer}>
            <Text style={styles.signatureSectionLabel}>License Type</Text>
            <Text style={styles.signatureSectionField}>{licenseType}</Text>
          </View>
          <View style={styles.signatureSectionFieldsContainer}>
            <Text style={styles.signatureSectionLabel}>Signature</Text>

            {signatureImages?.signatureImage ? (
              <View style={styles.signatureSectionImageContainer}>
                <Image src={signatureImages.signatureImage} style={styles.signatureImage} />
              </View>
            ) : (
              <Text style={styles.signatureSectionField}>-</Text>
            )}
          </View>
          <View style={styles.signatureSectionFieldsContainer}>
            <Text style={styles.signatureSectionLabel}>State Seal</Text>
            {signatureImages?.stateSealImage ? (
              <View style={styles.signatureSectionImageContainer}>
                <Image src={signatureImages.stateSealImage} style={styles.stateSealImage} />
              </View>
            ) : (
              <Text style={styles.signatureSectionField}>-</Text>
            )}
          </View>
          <View style={styles.signatureSectionFieldsContainer}>
            <Text style={styles.signatureSectionLabel}>Report Date</Text>
            <Text style={styles.signatureSectionField}>{signedAt ?? '-'}</Text>
          </View>
        </View>
      </View>
    </View>
  </Tkv2PDFPage>
);
